import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { PREDICTIONS_QUERY_KEYS } from "@/features/predictions/constants/queryKeys";
import { preferencesService } from "@/features/predictions/services/preferences.service";
import type { MyPronosticsPreferences } from "@/features/predictions/types/preferences.type";

const STALE_TIME_MS = 5 * 60 * 1000;

export const useMyPronosticsPreferences = (): UseQueryResult<MyPronosticsPreferences> => {
  return useQuery<MyPronosticsPreferences>({
    queryKey: PREDICTIONS_QUERY_KEYS.myPreferences(),
    queryFn: () => preferencesService.getMyPreferences(),
    staleTime: STALE_TIME_MS,
  });
};
